import { useRef, useEffect, useMemo } from "react";
import { useGetTickerQuery } from "../../RTK/Slices/Slices/apiSliceMeat";

const TickerBar = () => {
    const { data, isLoading, isError } = useGetTickerQuery();
    const messages = useMemo(() => data?.data ?? [], [data]);
    const trackRef   = useRef(null);
    const containerRef = useRef(null);
    const animRef    = useRef(null);
    const posRef     = useRef(null);      // موضع X الحالي

    /* دمج كل الرسائل في نص واحد بفاصل  •  */
    const fullText = messages.map(m => m.message).join("   •   ");
    /* متوسط السرعة من الرسائل */
    const speed = messages.length
        ? messages.reduce((s, m) => s + (m.speed || 40), 0) / messages.length
        : 40;
    /* ألوان من أول رسالة */
    const bgColor   = messages[0]?.bg_color ?? "#c0392b";
    const textColor = messages[0]?.color    ?? "#ffffff";

    /* ── تحريك بـ requestAnimationFrame ── */
    useEffect(() => {
        if (!trackRef.current || !containerRef.current || messages.length === 0) return;

        const track     = trackRef.current;
        const container = containerRef.current;

        // ابدأ من يمين الحاوية
        if (posRef.current === null) {
            posRef.current = container.offsetWidth;
        }

        const pxPerSec = speed * 1.5;   // تحويل الوحدة

        let lastTime: number | null = null;

        const step = (now: number) => {
            if (lastTime === null) lastTime = now;
            const dt = (now - lastTime) / 1000;   // ثواني
            lastTime = now;

            posRef.current -= pxPerSec * dt;

            // لو خرج من اليسار كلياً → أعد من اليمين
            if (posRef.current < -track.offsetWidth) {
                posRef.current = container.offsetWidth;
            }

            track.style.transform = `translateX(${posRef.current}px)`;
            animRef.current = requestAnimationFrame(step);
        };

        animRef.current = requestAnimationFrame(step);
        return () => { if (animRef.current) cancelAnimationFrame(animRef.current); };
    }, [messages, speed]);

    if (isLoading || isError || messages.length === 0) return null;

    return (
        <div
            ref={containerRef}
            dir="ltr"
            style={{
                background: bgColor,
                overflow: "hidden",
                whiteSpace: "nowrap",
                height: 42,
                display: "flex",
                alignItems: "center",
                position: "relative",
                width: "100%",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            }}
        >
            {/* أيقونة يمين */}
            <div
                style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    height: "100%",
                    padding: "0 14px",
                    background: "rgba(0,0,0,0.25)",
                    display: "flex",
                    alignItems: "center",
                    zIndex: 2,
                    color: textColor,
                    fontSize: 13,
                    fontWeight: "bold",
                    fontFamily: "Cairo, sans-serif",
                    gap: 6,
                    flexShrink: 0,
                }}
            >
                📢 إعلان
            </div>

            {/* النص المتحرك */}
            <span
                ref={trackRef}
                style={{
                    display: "inline-block",
                    color: textColor,
                    fontFamily: "Cairo, sans-serif",
                    fontSize: 15,
                    fontWeight: 600,
                    willChange: "transform",
                    paddingLeft: 40,
                    userSelect: "none",
                }}
            >
                {fullText}
            </span>
        </div>
    );
};

export default TickerBar;
